import { render } from "./DTabs.vue?vue&type=template&id=7fdd284e"
import script from "./DTabs.vue?vue&type=script&lang=ts"
export * from "./DTabs.vue?vue&type=script&lang=ts"
script.render = render

export default script